// extracted by mini-css-extract-plugin
module.exports = {"expand-search":"ExpandSearch_expand-search__N3qky","container":"ExpandSearch_container__Ru5I3"};